export default "__VITE_ASSET__vH3X06Rl__"